import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import RequireAuth from '../auth/RequireAuth';
import CollapsibleSidebarLayout from './CollapsibleSidebarLayout';
import DashboardHeader from './DashboardHeader';
import DashboardSidebar from './DashboardSidebar';
import UserGuard from './UserGuard';

import { AuthProvider } from '@/context/AuthContext';

const DashboardLayout = () => {
	const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(true);
	const toggleSidebar = () => {
		setIsSidebarOpen((prev) => !prev);
	};
	return (
		<>
			<AuthProvider>
				<RequireAuth>
					<UserGuard>
						<CollapsibleSidebarLayout
							sidebar={<DashboardSidebar />}
							header={<DashboardHeader onMenuClick={toggleSidebar} />}
							isSidebarOpen={isSidebarOpen}
							toggleSidebar={toggleSidebar}
							contentBg="bg-grey-10"
						>
							<Outlet />
						</CollapsibleSidebarLayout>
					</UserGuard>
				</RequireAuth>
			</AuthProvider>
		</>
	);
};

export default DashboardLayout;
